import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LayoutFocused from '../../../App/components/LayoutFocused/LayoutFocused';

import LoginWidget from './components/LoginWidget/LoginWidgetContainer';

const messages = defineMessages({
  title: {
    id: 'LoginPage.Title',
    defaultMessage: 'Log in',
  },
});

function LoginPage() {
  const { formatMessage } = useIntl();
  const [messagesPortal, setMessagesPortal] = useState(null);
  return (
    <LayoutFocused
      title={formatMessage(messages.title)}
      maxWidth="md"
      messagesPortal={messagesPortal}
    >
      <LoginWidget isSignup={false} showSignupLink messagesPortalRef={setMessagesPortal} />
    </LayoutFocused>
  );
}

export default LoginPage;
